import { cssVar, defineStyleConfig } from "@chakra-ui/react";

const $startColor = cssVar("skeleton-start-color");
const $endColor = cssVar("skeleton-end-color");

const baseStyle = {
  [$startColor.variable]: "colors.gray.100",
  [$endColor.variable]: "colors.gray.200",
  borderRadius: "18px",
  width: "100%",
};

export const Skeleton = defineStyleConfig({
  baseStyle,
});
